<template>
  <b-modal
    v-model="visible"
    title="Recursos"
  >
    <b-form-group label="Título">
      <div v-if="!$role(['administrador'])">{{ post.titulo }}</div>
      <b-form-input
        v-else
        placeholder="Título"
        v-model="post.titulo"
      />
    </b-form-group>
    <b-form-group label="Descripción">
      <div v-if="!$role(['administrador'])">{{ post.cuerpo }}</div>
      <b-textarea
        v-else
        placeholder="Descripción"
        v-model="post.cuerpo"
      ></b-textarea>
    </b-form-group>
    <template v-slot:modal-footer>
      <div class="w-100 d-flex justify-content-between">
        <div>
          <b-button
            variant="danger"
            v-if="$role(['administrador'])"
            @click="deletePost(post.id)"
          >Eliminar</b-button>
        </div>
        <div>
          <b-button
            v-if="post.archivo"
            variant="link"
            class="mr-2"
            @click="download(post.id)"
          >Descargar archivo</b-button>
          <b-button
            variant="primary"
            @click="ok(post.id)"
          >
            <span v-if="!$role(['administrador'])">Aceptar</span>
            <span v-else>Guardar Cambios</span>
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalShowElementComponent',
  data () {
    return {
      visible: false,
      post: {},
      id: null
    }
  },

  methods: {
    ok (id) {
      if (this.$role(['administrador'])) {
        // save changes
        this.$api.patch('recursos/post/' + id, this.post).then(() => {
          this.$toast.success('Actualización exitosa.')
          this.$emit('updated')
        })
      }
      this.visible = false
    },
    openPost (id) {
      this.$api('recursos/post/' + id).then(res => {
        this.post = res.data
      })
    },
    deletePost (id) {
      const conf = confirm('¿Desea eliminar el elemento seleccionado?')
      if (conf) {
        this.$api.delete('recursos/post/' + id).then(() => {
          this.$toast.success('Se ha eliminado el elemento y su archivo.')
          this.visible = false
          this.$emit('deleted')
        })
      }
    },
    download (id) {
      this.$api({
        url: 'recursos/descargar-archivo?post_id=' + id,
        method: 'GET',
        responseType: 'blob'
      }).then(res => {
        const fileURL = URL.createObjectURL(res.data);
        window.open(fileURL);
      }).catch(err => {
        const toast = this.$toast;
        const fr = new FileReader();
        fr.onload = function () {
          toast.error('No se puede descargar el archivo. ');
        };
        fr.readAsText(err.response.data);
      });
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.openPost(this.id)
      }
    }
  }
}
</script>
